import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

import { MessageService } from '@services/message.service';
import { ConfiguracaoCaixaApiService } from '../../../services/configuracao-caixa-api.service';

@Component({
  selector: 'app-add-conta-caixa-dialog',
  standalone: false,
  templateUrl: './add-conta-caixa-dialog.component.html',
  styleUrl: './add-conta-caixa-dialog.component.scss'
})
export class AddContaCaixaDialogComponent {

  title: string = '';
  nome: string = '';

  constructor(
    private configuracaoCaixaApiService: ConfiguracaoCaixaApiService,
    private messageService: MessageService,
    private dialogRef: MatDialogRef<AddContaCaixaDialogComponent>
  ) { }

  public salvarClick(): void {
    if (!this.nome?.trim()) {
      this.messageService.showToastWarning("O nome não pode ser vazio")
      return;
    }

    this.configuracaoCaixaApiService.saveCriarContaCaixa(this.nome).subscribe(() => {
      this.messageService.showToastSuccess("Salvo com sucesso")
      this.dialogRef.close(true);
    });
  }
}
